module.exports = __webpack_public_path__ + "img/140.6d17d75c.png";